import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const MetaInspection: ITypeSpecificPolicy<types.MetaInspection> = {
  fields: {
    createdAt: dateTimeFieldPolicy(),
    inspectionUpdated: dateTimeFieldPolicy()
  }
};
